import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const EDropzoneFileErrorCodes = {
	tooManyFiles: 'too-many-files',
	fileInvalidType: 'file-invalid-type',
	fileTooLarge: 'file-too-large',
} as const;

export const EImportingDataType = {
	asset: 'asset',
	polygon: 'polygon',
	site: 'site',
} as const;

export type TDropzoneFileErrorCodes = TValueOfStringRecord<typeof EDropzoneFileErrorCodes>
export type TImportingDataType = TValueOfStringRecord<typeof EImportingDataType>
